import { useTranslation } from 'react-i18next';
import { useState } from 'react';

import type { QltAvatar } from '../../api/types';
import { avatarSrc } from './portrait';

function Silhouette() {
  return (
    <svg width="60" height="72" viewBox="0 0 60 72" aria-hidden={true}>
      <rect width="60" height="72" fill="var(--color-thumb-bg)" />
      <circle cx="30" cy="28" r="11" fill="var(--color-border-strong)" />
      <path d="M9 72c0-11.6 9.4-21 21-21s21 9.4 21 21z" fill="var(--color-border-strong)" />
    </svg>
  );
}

export interface StudentPortraitProps {
  avatar: QltAvatar | null | undefined;
  name: string;
}

export function StudentPortrait({ avatar, name }: StudentPortraitProps) {
  const { t } = useTranslation('panels');
  const src = avatarSrc(avatar);
  // remembers which src broke, so a new avatar on the same row gets its own attempt
  const [failedSrc, setFailedSrc] = useState<string | null>(null);
  return (
    <span className="cm-portrait">
      {src && src !== failedSrc
        ? <img src={src} alt={t('student.photoAlt', { name })} width={60} height={72} loading="lazy" decoding="async" onError={() => setFailedSrc(src)} />
        : <Silhouette />}
    </span>
  );
}
